module.exports = __webpack_public_path__ + "assets/images/9d6e2eeac97910301a1c234c386e0ec1.png";